<template>
  <section class="products-layout">
    <template v-if="displayedProducts.length && !$store.state.view.isLoading && !forceLoading && !$store.state.view.isLoadingProducts || !$store.state.view.isLoading && featuredProducts">
      <WellsTable v-if="type === 'wells'" :displayedProducts="displayedProducts" :prefix="prefix"/>
      <KaaliGrid
        v-else-if="type === 'kaali'"
        :displayedProducts="displayedProducts"
        :prefix="prefix"
        :isCarousel="isCarousel" 
      />
    </template>

    <div v-else-if="$store.state.view.isLoading || forceLoading || $store.state.view.isLoadingProducts">
      <div class="placeholders">
        <content-placeholders v-for="i in placeholderCount" :key="`placeholder-${i}`">
          <content-placeholders-heading :img="true" />
        </content-placeholders>
      </div>
    </div>

    <div v-else-if=" ! this.$store.state.filters.keyword && Object.keys($store.state.filters.current).length === 0">
      {{ translations.noTaxonomySelected }}
    </div>
  </section>
</template>

<style lang="scss" scoped>
.placeholders {
  display: flex;
  flex-direction: column;

  .vue-content-placeholders {
    margin: 2.5rem 0;
  }
}
</style>

<script>
import WellsTable from "./table/Wells.vue";
import KaaliGrid from "./grid/Kaali.vue";

export default {
  components: {
    WellsTable,
    KaaliGrid
  },
  name: "ProductsLayout",
  props: {
    placeholderCount: {
      type: Number,
      default() {
        return 10;
      }
    },
    forceDisplayProducts: {
      type: Array,
      default() {
        return [];
      }
    },
    prefix: {
      type: String,
      default() {
        return "";
      }
    },
    forceLoading: {
      type: Boolean,
      default() {
        return false;
      }
    },
    featuredProducts: {
      type: Boolean,
      default() {
        return false;
      }
    },
    isCarousel: {
      type: Boolean,
      default() {
        return false;
      }
    }
  },
  data() {
    return {
      //type: ws_vue_store.config["product-grid"],
      translations: {
        noProductsMatch: ws_vue_store.translations.no_products_match,
        noTaxonomySelected: ws_vue_store.translations.no_taxonomy_selected
      },
      buttonVisible: false
    };
  },
  computed: {
    type() {
      if(this.featuredProducts) return 'kaali';
      return this.$store.getters.getType;
    },
    displayedProducts() {
      if (this.forceDisplayProducts === null) {
        return [];
      }
      if (this.forceDisplayProducts.length !== 0) {
        return this.forceDisplayProducts;
      }

      return this.$store.getters.getProducts;
    },
  },
  methods: {
    handleScroll() {
    const scrollTop = window.scrollY || document.documentElement.scrollTop;
    const offset = 150;

    if (scrollTop > offset) {
      setTimeout(() => {
        this.buttonVisible = true;
      });
    } else if (scrollTop < offset) {
      this.buttonVisible = false;
    }
  }
  },
  // mounted() {
  //   window.addEventListener("scroll", this.handleScroll);
  // },
  // beforeDestroy() {
  //   window.removeEventListener("scroll", this.handleScroll);
  // }
};
</script>
